var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampaignIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.0049C18 12.5549 18.45 13.0049 19 13.0049H21C21.55 13.0049 22 12.5549 22 12.0049C22 11.4549 21.55 11.0049 21 11.0049H19C18.45 11.0049 18 11.4549 18 12.0049Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.59 16.8249C16.26 17.2649 16.35 17.8749 16.79 18.1949C17.32 18.5849 17.88 19.0049 18.41 19.4049C18.85 19.7349 19.47 19.6449 19.79 19.2049C19.79 19.1949 19.8 19.1949 19.8 19.1849C20.13 18.7449 20.04 18.1249 19.6 17.8049C19.07 17.4049 18.51 16.9849 17.99 16.5949C17.55 16.2649 16.93 16.3649 16.6 16.8049C16.6 16.8149 16.59 16.8249 16.59 16.8249Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.81 4.81493C19.81 4.80493 19.8 4.80493 19.8 4.79493C19.47 4.35493 18.85 4.26493 18.42 4.59493C17.89 4.99493 17.32 5.41493 16.8 5.81493C16.36 6.14493 16.28 6.76493 16.61 7.19493C16.61 7.20493 16.62 7.20493 16.62 7.21493C16.95 7.65493 17.56 7.74493 18 7.41493C18.53 7.02493 19.09 6.59493 19.62 6.19493C20.05 5.87493 20.13 5.25493 19.81 4.81493Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.00493H4C2.9 9.00493 2 9.90493 2 11.0049V13.0049C2 14.1049 2.9 15.0049 4 15.0049H5V18.0049C5 18.5549 5.45 19.0049 6 19.0049C6.55 19.0049 7 18.5549 7 18.0049V15.0049H8L13 18.0049V6.00493L8 9.00493Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.0049C15.5 10.6749 14.92 9.47493 14 8.65493V15.3449C14.92 14.5349 15.5 13.3349 15.5 12.0049Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignIcon);
export default __webpack_public_path__ + "static/media/CampaignIcon.c9bdabeddaeb9765c33274ad84cc4398.svg";
export { ForwardRef as ReactComponent };